const outlineColor = {
  name: "outline-color",
  path: "/outline-color",
  title: "outline-color",
  description: "Utilities for controlling the color of an element's borders.",
  value: {
  "outline-color": {
    "outline-color-inherit": "inherit",
    "outline-color-current": "currentColor",
    "outline-color-transparent": "transparent",
    "outline-color-[<value>]": "<value>",
    "outline-color-black": "var(--color-black)",
    "outline-color-white": "var(--color-white)",
    "outline-color-red-50": "var(--color-red-50)",
    "outline-color-red-100": "var(--color-red-100)",
    "outline-color-red-200": "var(--color-red-200)",
    "outline-color-red-300": "var(--color-red-300)",
    "outline-color-red-400": "var(--color-red-400)",
    "outline-color-red-500": "var(--color-red-500)",
    "outline-color-red-600": "var(--color-red-600)",
    "outline-color-red-700": "var(--color-red-700)",
    "outline-color-red-800": "var(--color-red-800)",
    "outline-color-red-900": "var(--color-red-900)",
    "outline-color-orange-50": "var(--color-orange-50)",
    "outline-color-orange-100": "var(--color-orange-100)",
    "outline-color-orange-200": "var(--color-orange-200)",
    "outline-color-orange-300": "var(--color-orange-300)",
    "outline-color-orange-400": "var(--color-orange-400)",
    "outline-color-orange-500": "var(--color-orange-500)",
    "outline-color-orange-600": "var(--color-orange-600)",
    "outline-color-orange-700": "var(--color-orange-700)",
    "outline-color-orange-800": "var(--color-orange-800)",
    "outline-color-orange-900": "var(--color-orange-900)",
    "outline-color-amber-50": "var(--color-amber-50)",
    "outline-color-amber-100": "var(--color-amber-100)",
    "outline-color-amber-200": "var(--color-amber-200)",
    "outline-color-amber-300": "var(--color-amber-300)",
    "outline-color-amber-400": "var(--color-amber-400)",
    "outline-color-amber-500": "var(--color-amber-500)",
    "outline-color-amber-600": "var(--color-amber-600)",
    "outline-color-amber-700": "var(--color-amber-700)",
    "outline-color-amber-800": "var(--color-amber-800)",
    "outline-color-amber-900": "var(--color-amber-900)",
    "outline-color-yellow-50": "var(--color-yellow-50)",
    "outline-color-yellow-100": "var(--color-yellow-100)",
    "outline-color-yellow-200": "var(--color-yellow-200)",
    "outline-color-yellow-300": "var(--color-yellow-300)",
    "outline-color-yellow-400": "var(--color-yellow-400)",
    "outline-color-yellow-500": "var(--color-yellow-500)",
    "outline-color-yellow-600": "var(--color-yellow-600)",
    "outline-color-yellow-700": "var(--color-yellow-700)",
    "outline-color-yellow-800": "var(--color-yellow-800)",
    "outline-color-yellow-900": "var(--color-yellow-900)",
    "outline-color-lime-50": "var(--color-lime-50)",
    "outline-color-lime-100": "var(--color-lime-100)",
    "outline-color-lime-200": "var(--color-lime-200)",
    "outline-color-lime-300": "var(--color-lime-300)",
    "outline-color-lime-400": "var(--color-lime-400)",
    "outline-color-lime-500": "var(--color-lime-500)",
    "outline-color-lime-600": "var(--color-lime-600)",
    "outline-color-lime-700": "var(--color-lime-700)",
    "outline-color-lime-800": "var(--color-lime-800)",
    "outline-color-lime-900": "var(--color-lime-900)",
    "outline-color-green-50": "var(--color-green-50)",
    "outline-color-green-100": "var(--color-green-100)",
    "outline-color-green-200": "var(--color-green-200)",
    "outline-color-green-300": "var(--color-green-300)",
    "outline-color-green-400": "var(--color-green-400)",
    "outline-color-green-500": "var(--color-green-500)",
    "outline-color-green-600": "var(--color-green-600)",
    "outline-color-green-700": "var(--color-green-700)",
    "outline-color-green-800": "var(--color-green-800)",
    "outline-color-green-900": "var(--color-green-900)",
    "outline-color-emerald-50": "var(--color-emerald-50)",
    "outline-color-emerald-100": "var(--color-emerald-100)",
    "outline-color-emerald-200": "var(--color-emerald-200)",
    "outline-color-emerald-300": "var(--color-emerald-300)",
    "outline-color-emerald-400": "var(--color-emerald-400)",
    "outline-color-emerald-500": "var(--color-emerald-500)",
    "outline-color-emerald-600": "var(--color-emerald-600)",
    "outline-color-emerald-700": "var(--color-emerald-700)",
    "outline-color-emerald-800": "var(--color-emerald-800)",
    "outline-color-emerald-900": "var(--color-emerald-900)",
    "outline-color-teal-50": "var(--color-teal-50)",
    "outline-color-teal-100": "var(--color-teal-100)",
    "outline-color-teal-200": "var(--color-teal-200)",
    "outline-color-teal-300": "var(--color-teal-300)",
    "outline-color-teal-400": "var(--color-teal-400)",
    "outline-color-teal-500": "var(--color-teal-500)",
    "outline-color-teal-600": "var(--color-teal-600)",
    "outline-color-teal-700": "var(--color-teal-700)",
    "outline-color-teal-800": "var(--color-teal-800)",
    "outline-color-teal-900": "var(--color-teal-900)",
    "outline-color-cyan-50": "var(--color-cyan-50)",
    "outline-color-cyan-100": "var(--color-cyan-100)",
    "outline-color-cyan-200": "var(--color-cyan-200)",
    "outline-color-cyan-300": "var(--color-cyan-300)",
    "outline-color-cyan-400": "var(--color-cyan-400)",
    "outline-color-cyan-500": "var(--color-cyan-500)",
    "outline-color-cyan-600": "var(--color-cyan-600)",
    "outline-color-cyan-700": "var(--color-cyan-700)",
    "outline-color-cyan-800": "var(--color-cyan-800)",
    "outline-color-cyan-900": "var(--color-cyan-900)",
    "outline-color-sky-50": "var(--color-sky-50)",
    "outline-color-sky-100": "var(--color-sky-100)",
    "outline-color-sky-200": "var(--color-sky-200)",
    "outline-color-sky-300": "var(--color-sky-300)",
    "outline-color-sky-400": "var(--color-sky-400)",
    "outline-color-sky-500": "var(--color-sky-500)",
    "outline-color-sky-600": "var(--color-sky-600)",
    "outline-color-sky-700": "var(--color-sky-700)",
    "outline-color-sky-800": "var(--color-sky-800)",
    "outline-color-sky-900": "var(--color-sky-900)",
    "outline-color-blue-50": "var(--color-blue-50)",
    "outline-color-blue-100": "var(--color-blue-100)",
    "outline-color-blue-200": "var(--color-blue-200)",
    "outline-color-blue-300": "var(--color-blue-300)",
    "outline-color-blue-400": "var(--color-blue-400)",
    "outline-color-blue-500": "var(--color-blue-500)",
    "outline-color-blue-600": "var(--color-blue-600)",
    "outline-color-blue-700": "var(--color-blue-700)",
    "outline-color-blue-800": "var(--color-blue-800)",
    "outline-color-blue-900": "var(--color-blue-900)",
    "outline-color-indigo-50": "var(--color-indigo-50)",
    "outline-color-indigo-100": "var(--color-indigo-100)",
    "outline-color-indigo-200": "var(--color-indigo-200)",
    "outline-color-indigo-300": "var(--color-indigo-300)",
    "outline-color-indigo-400": "var(--color-indigo-400)",
    "outline-color-indigo-500": "var(--color-indigo-500)",
    "outline-color-indigo-600": "var(--color-indigo-600)",
    "outline-color-indigo-700": "var(--color-indigo-700)",
    "outline-color-indigo-800": "var(--color-indigo-800)",
    "outline-color-indigo-900": "var(--color-indigo-900)",
    "outline-color-violet-50": "var(--color-violet-50)",
    "outline-color-violet-100": "var(--color-violet-100)",
    "outline-color-violet-200": "var(--color-violet-200)",
    "outline-color-violet-300": "var(--color-violet-300)",
    "outline-color-violet-400": "var(--color-violet-400)",
    "outline-color-violet-500": "var(--color-violet-500)",
    "outline-color-violet-600": "var(--color-violet-600)",
    "outline-color-violet-700": "var(--color-violet-700)",
    "outline-color-violet-800": "var(--color-violet-800)",
    "outline-color-violet-900": "var(--color-violet-900)",
    "outline-color-purple-50": "var(--color-purple-50)",
    "outline-color-purple-100": "var(--color-purple-100)",
    "outline-color-purple-200": "var(--color-purple-200)",
    "outline-color-purple-300": "var(--color-purple-300)",
    "outline-color-purple-400": "var(--color-purple-400)",
    "outline-color-purple-500": "var(--color-purple-500)",
    "outline-color-purple-600": "var(--color-purple-600)",
    "outline-color-purple-700": "var(--color-purple-700)",
    "outline-color-purple-800": "var(--color-purple-800)",
    "outline-color-purple-900": "var(--color-purple-900)",
    "outline-color-fuchsia-50": "var(--color-fuchsia-50)",
    "outline-color-fuchsia-100": "var(--color-fuchsia-100)",
    "outline-color-fuchsia-200": "var(--color-fuchsia-200)",
    "outline-color-fuchsia-300": "var(--color-fuchsia-300)",
    "outline-color-fuchsia-400": "var(--color-fuchsia-400)",
    "outline-color-fuchsia-500": "var(--color-fuchsia-500)",
    "outline-color-fuchsia-600": "var(--color-fuchsia-600)",
    "outline-color-fuchsia-700": "var(--color-fuchsia-700)",
    "outline-color-fuchsia-800": "var(--color-fuchsia-800)",
    "outline-color-fuchsia-900": "var(--color-fuchsia-900)",
    "outline-color-pink-50": "var(--color-pink-50)",
    "outline-color-pink-100": "var(--color-pink-100)",
    "outline-color-pink-200": "var(--color-pink-200)",
    "outline-color-pink-300": "var(--color-pink-300)",
    "outline-color-pink-400": "var(--color-pink-400)",
    "outline-color-pink-500": "var(--color-pink-500)",
    "outline-color-pink-600": "var(--color-pink-600)",
    "outline-color-pink-700": "var(--color-pink-700)",
    "outline-color-pink-800": "var(--color-pink-800)",
    "outline-color-pink-900": "var(--color-pink-900)",
    "outline-color-rose-50": "var(--color-rose-50)",
    "outline-color-rose-100": "var(--color-rose-100)",
    "outline-color-rose-200": "var(--color-rose-200)",
    "outline-color-rose-300": "var(--color-rose-300)",
    "outline-color-rose-400": "var(--color-rose-400)",
    "outline-color-rose-500": "var(--color-rose-500)",
    "outline-color-rose-600": "var(--color-rose-600)",
    "outline-color-rose-700": "var(--color-rose-700)",
    "outline-color-rose-800": "var(--color-rose-800)",
    "outline-color-rose-900": "var(--color-rose-900)",
    "outline-color-slate-50": "var(--color-slate-50)",
    "outline-color-slate-100": "var(--color-slate-100)",
    "outline-color-slate-200": "var(--color-slate-200)",
    "outline-color-slate-300": "var(--color-slate-300)",
    "outline-color-slate-400": "var(--color-slate-400)",
    "outline-color-slate-500": "var(--color-slate-500)",
    "outline-color-slate-600": "var(--color-slate-600)",
    "outline-color-slate-700": "var(--color-slate-700)",
    "outline-color-slate-800": "var(--color-slate-800)",
    "outline-color-slate-900": "var(--color-slate-900)",
    "outline-color-gray-50": "var(--color-gray-50)",
    "outline-color-gray-100": "var(--color-gray-100)",
    "outline-color-gray-200": "var(--color-gray-200)",
    "outline-color-gray-300": "var(--color-gray-300)",
    "outline-color-gray-400": "var(--color-gray-400)",
    "outline-color-gray-500": "var(--color-gray-500)",
    "outline-color-gray-600": "var(--color-gray-600)",
    "outline-color-gray-700": "var(--color-gray-700)",
    "outline-color-gray-800": "var(--color-gray-800)",
    "outline-color-gray-900": "var(--color-gray-900)",
    "outline-color-zinc-50": "var(--color-zinc-50)",
    "outline-color-zinc-100": "var(--color-zinc-100)",
    "outline-color-zinc-200": "var(--color-zinc-200)",
    "outline-color-zinc-300": "var(--color-zinc-300)",
    "outline-color-zinc-400": "var(--color-zinc-400)",
    "outline-color-zinc-500": "var(--color-zinc-500)",
    "outline-color-zinc-600": "var(--color-zinc-600)",
    "outline-color-zinc-700": "var(--color-zinc-700)",
    "outline-color-zinc-800": "var(--color-zinc-800)",
    "outline-color-zinc-900": "var(--color-zinc-900)",
    "outline-color-neutral-50": "var(--color-neutral-50)",
    "outline-color-neutral-100": "var(--color-neutral-100)",
    "outline-color-neutral-200": "var(--color-neutral-200)",
    "outline-color-neutral-300": "var(--color-neutral-300)",
    "outline-color-neutral-400": "var(--color-neutral-400)",
    "outline-color-neutral-500": "var(--color-neutral-500)",
    "outline-color-neutral-600": "var(--color-neutral-600)",
    "outline-color-neutral-700": "var(--color-neutral-700)",
    "outline-color-neutral-800": "var(--color-neutral-800)",
    "outline-color-neutral-900": "var(--color-neutral-900)",
    "outline-color-stone-50": "var(--color-stone-50)",
    "outline-color-stone-100": "var(--color-stone-100)",
    "outline-color-stone-200": "var(--color-stone-200)",
    "outline-color-stone-300": "var(--color-stone-300)",
    "outline-color-stone-400": "var(--color-stone-400)",
    "outline-color-stone-500": "var(--color-stone-500)",
    "outline-color-stone-600": "var(--color-stone-600)",
    "outline-color-stone-700": "var(--color-stone-700)",
    "outline-color-stone-800": "var(--color-stone-800)",
    "outline-color-stone-900": "var(--color-stone-900)"
  }
},
  exampleData: [
    {
      example: {
        code: `<button class="outline-2 outline-offset-2 outline-color-red-500 ...">Button A</button>
<button class="outline-2 outline-offset-2 outline-color-blue-500 ...">Button B</button>
<button class="outline-2 outline-offset-2 outline-color-orange-500 ...">Button C</button>
<button class="outline-2 outline-offset-2 outline-color-[#ffc107] ...">Button D</button>`
      }
    },
    {
      example: {
        code: `<button class="outline-2 outline-offset-2 outline-color-red-500/75 ...">Button A</button>
<button class="outline-2 outline-offset-2 outline-color-red-500/50 ...">Button B</button>
<button class="outline-2 outline-offset-2 outline-color-red-500/25 ...">Button C</button>`
      }
    }
  ],
  htmlData: [
   {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-color-indigo-500</code>, and
        <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-color-lime-100</code>
        to control the border color of an element:
      </p>
      <div class="flex justify-center gap-6 items-center text-sm flex-wrap text-color-gray-500">
          <button class="outline-2 outline-offset-2 outline-color-red-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button A</button>
          <button class="outline-2 outline-offset-2 outline-color-blue-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button B</button>
          <button class="outline-2 outline-offset-2 outline-color-orange-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button C</button>
          <button class="outline-2 outline-offset-2 outline-color-[#ffc107] rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button D</button>
      </div>
      `
    },
   {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">Changing the opacity</code>
        Use the color opacity modifier to control the opacity of an element's outline color:
      </p>
      <div class="flex justify-center gap-6 items-center text-sm flex-wrap text-color-gray-500">
          <button class="outline-2 outline-offset-2 outline-color-red-500/75 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button A</button>
          <button class="outline-2 outline-offset-2 outline-color-red-500/50 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button B</button>
          <button class="outline-2 outline-offset-2 outline-color-red-500/25 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button C</button>
      </div>
      `
    }
]
}
export default outlineColor;

<div class="sr-only outline-color-red-500/75 outline-color-red-500/50 outline-color-red-500/25 outline-color-red-500 outline-color-blue-500 outline-color-orange-500 outline-color-[#ffc107]">
</div>